import { Cookies } from "react-cookie";


export const setCookies = (name, value) => {
    const cookies = new Cookies();
    return cookies.set(name, value);
}

export const removeCookies = (name) => {
    const cookies = new Cookies();
    return cookies.remove(name);
}

export const cleareCookies = () => {
    const cookies = new Cookies();
    return cookies.remove();
}
export const getCookies = (name) => {
    const cookies = new Cookies();
    return cookies.get(name);
};